import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { toast } from "sonner";
import { Clock, Calendar, ArrowRight } from "lucide-react";

export default function ChaplainHistory() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/care-coordination/my-history?limit=300")
      .then((r) => setEvents(r.data || []))
      .catch(() => toast.error("Failed to load history"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="chap-history">
      <h2 className="font-heading text-2xl tracking-tight text-slate-900 flex items-center gap-2">
        <Clock className="w-6 h-6 text-[#4A6FA5]" strokeWidth={1.75} /> My Activity / History
      </h2>
      <p className="mt-1 text-sm text-slate-500 max-w-2xl">
        A chronological record of actions you've taken on your assignments. Only events you authored are shown.
      </p>

      <div className="mt-6 bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-6 text-sm text-slate-500">Loading…</p>
        ) : events.length === 0 ? (
          <p className="p-6 text-sm text-slate-500">No history entries yet.</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {events.map((e, i) => (
              <li key={i} className="p-4 flex items-start justify-between gap-4 hover:bg-slate-50">
                <div className="min-w-0">
                  <p className="text-sm text-slate-900">
                    <span className="font-medium">{e.type?.replace(/_/g, " ")}</span>
                    {e.from_stage && e.to_stage ? (
                      <span className="text-slate-500"> · {e.from_stage} → {e.to_stage}</span>
                    ) : e.contact_type ? (
                      <span className="text-slate-500"> · {e.contact_type}</span>
                    ) : null}
                  </p>
                  <p className="text-xs text-slate-500 mt-1">
                    <Calendar className="inline w-3.5 h-3.5 mr-1" />
                    {new Date(e.at).toLocaleString()} · {e.record_label} · {e.record_org}
                    {e.reason ? ` · reason: ${e.reason}` : ""}
                  </p>
                </div>
                <Link
                  to={`/chaplain-portal/care/${e.record_id}`}
                  className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium text-[#4A6FA5] hover:bg-blue-50 shrink-0"
                >
                  Open <ArrowRight className="w-3 h-3" />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
